import { OnlyContentTypes } from 'govbr.frontend.policy/helpers/BlockConditions';
import { defineMessages } from 'react-intl';

import EventInfoEdit from './EventInfoEdit';
import EventInfoView from './EventInfoView';
import EventInfoSchema from './schema';

import iconSVG from '@plone/volto/icons/info.svg';

defineMessages({
  eventInfoBlock: {
    id: 'Event information',
    defaultMessage: 'Event information',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.eventInfoBlock = {
    id: 'eventInfoBlock',
    title: 'Event information',
    group: 'organization',
    blockSchema: EventInfoSchema,
    icon: iconSVG,
    view: EventInfoView,
    edit: EventInfoEdit,
    mostUsed: true,
    restricted: OnlyContentTypes(['Event']),
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
